/** @enum {string} */
const VisibilityValues = Object.freeze({
  EXTERNAL: 'external',
  INTERNAL: 'internal',
  ALL: 'all'
})

export default VisibilityValues